module.exports = __webpack_public_path__ + "img/HQ-OA-360V05NL-T.6017bacf.jpg";